import React from "react";
import { FormProvider } from "react-hook-form";

import Box from "@mui/material/Box";
import Link from "@mui/material/Link";
import Collapse from "@mui/material/Collapse";
import Typography from "@mui/material/Typography";

import Button from "components/Button";
import { FormInput } from "components/FormInput";

import { AuthStep, useAuthForm } from "./useAuthForm";

const AuthForm: React.FC = () => {
  const {
    step,
    isNewUser,
    isLoading,
    isSocialMediaLoading,
    methods,
    targetRef,
    ProxyInput,
    handleFormSubmit,
    onForgotPassword,
  } = useAuthForm();

  return (
    <Box
      component="form"
      noValidate
      onSubmit={handleFormSubmit}
      onKeyDown={(e: React.KeyboardEvent) => {
        if (e.key === "Enter" && e.target instanceof HTMLInputElement) {
          e.preventDefault();
          handleFormSubmit(e);
        }
      }}
    >
      <FormProvider {...methods}>
        <ProxyInput />
        <FormInput
          title="Email"
          name="email"
          fullWidth
          type="email"
          autoComplete="username"
          testId="email-input"
        />
        <Collapse in={step === AuthStep.Auth}>
          {step === AuthStep.Auth && (
            <FormInput
              title="Пароль"
              name="password"
              fullWidth
              type="password"
              testId="password-input"
              sx={{ mb: 0 }}
              inputRef={targetRef}
              autoComplete={isNewUser ? "new-password" : "current-password"}
            />
          )}
          {!isNewUser && (
            <Typography variant="subtitle2" textAlign="left" sx={{ mt: 1 }}>
              <Link
                component="button"
                type="button"
                onClick={onForgotPassword}
                color="grey700"
                variant="subtitle2"
                data-testid="forgot-password-link"
              >
                Забули пароль?
              </Link>
            </Typography>
          )}
        </Collapse>
      </FormProvider>

      <Button
        sx={{ mt: 3 }}
        variant="contained"
        color="primary"
        fullWidth
        type="submit"
        disabled={isSocialMediaLoading}
        loading={isLoading}
        data-testid="auth-button"
      >
        {step === AuthStep.CheckEmail
          ? "Продовжити"
          : isNewUser
            ? "Створити профіль"
            : "Увійти"}
      </Button>
    </Box>
  );
};

export default AuthForm;
